/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit GenerateHsaFsaReceipt/view.blocks to change it.
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function GenerateHsaFsaReceipt({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/MoreAction/Content/GenerateHsaFsaReceipt"
  
}) {
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 type="ghost"
 width="100%"
 text="Generate HSA / FSA receipts"
/>
{children}
</React.Fragment>)
}